var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.inited
        ? _c("c-loader", { attrs: { active: !_vm.inited, height: 100 } })
        : _vm._e(),
      _c("custom-form", {
        ref: "form",
        attrs: {
          inited: _vm.inited,
          form: _vm.form,
          "is-submitted": _vm.isSubmitted,
          blocked: _vm.field && _vm.field.blocked,
          warning: _vm.showWarning,
        },
        on: {
          submit: _vm.submit,
          changeDictionary: function ($event) {
            _vm.changedDictionary = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }